export var userMenuList = [
    {
        linkName: 'Profile',
        linkPath: '/profile',
        icon: 'user',
        elevated: false,
    },
    {
        linkName: 'Maintenance',
        linkPath: '/maintenance',
        icon: 'wrench',
        elevated: true,
    },
    // {
    //   linkName: 'Settings',
    //   linkPath: '/settings',
    //   icon: 'cog',
    //   elevated: true,
    // },
    {
        linkName: 'Help',
        linkPath: '/Help',
        icon: 'question',
        elevated: false,
    },
];
